import React from 'react'
import { Button, Form, Modal } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';


const CreateBanner = ({ show, handleClose, loading, selectedBanner, loadOptionsProducts, products, onProductChange, customStyless, formik, handleWebImageChange, handleMobImageChange }) => {
    return (
        <React.Fragment>
            <Modal
                show={show}
                onHide={handleClose}
                centered
                className="modal_create"
                size="lg"
            >
                <Form onSubmit={formik.handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>{selectedBanner?.id ? 'Update' :'Create'} Banner</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="modal_content_wrapper">
                            <div className="row">
                                <div className="col-lg-6">
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Title</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter title"
                                            name='title'
                                            value={formik.values?.title}
                                            onChange={formik.handleChange}
                                            isValid={formik.touched.title && !formik.errors.title}
                                            isInvalid={formik.touched.title && !!formik.errors.title}
                                        />
                                        <Form.Control.Feedback type="invalid">{formik.errors.title}</Form.Control.Feedback>
                                    </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                    <Form.Group controlId="formFileMultiple" className="mb-3">
                                        <Form.Label>Web Image</Form.Label>
                                        <Form.Control
                                            type="file"
                                            onChange={handleWebImageChange}
                                            isInvalid={formik.touched.webImage && formik.errors.webImage}
                                            error={formik.errors.webImage}
                                        />
                                        <Form.Control.Feedback type="invalid">{formik.errors.webImage}</Form.Control.Feedback>
                                        {formik.values.webImage_view &&
                                            <img src={formik.values.webImage_view} alt='Category' className='mb-2' height={150} width={150} />
                                        }

                                    </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                    <Form.Group controlId="formFileMultiple" className="mb-3">
                                        <Form.Label>Mobile Image</Form.Label>
                                        <Form.Control
                                            type="file"
                                            onChange={handleMobImageChange}
                                            isInvalid={formik.touched.mobileImage && formik.errors.mobileImage}
                                            error={formik.errors.mobileImage}
                                        />
                                        <Form.Control.Feedback type="invalid">{formik.errors.mobileImage}</Form.Control.Feedback>
                                        {formik.values.mobileImage_view &&
                                            <img src={formik.values.mobileImage_view} alt='Category' className='mb-2' height={150} width={150} />
                                        }

                                    </Form.Group>
                                </div>
                                <div className='col-lg-6'>
                                    <Form.Group>
                                        <Form.Label>Products</Form.Label>
                                        <AsyncSelect
                                            loadOptions={loadOptionsProducts}
                                            defaultOptions={products}
                                            classNamePrefix="select"
                                            isClearable={true}
                                            placeholder={'Search Products'}
                                            onChange={onProductChange}
                                            value={formik.values.selectedProduct}
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: "0 10px 10px 10px",
                                                colors: {
                                                    ...theme.colors,
                                                    primary: '#779be1',
                                                },
                                            })}
                                            styles={customStyless}
                                        />
                                        {/* <Form.Select
                                    onChange={formik.handleChange}
                                    name='subCategoryId'
                                    value={formik.values.subCategoryId}
                                    isInvalid={formik.touched.subCategoryId && formik.errors.subCategoryId}
                                    error={formik.errors.subCategoryId}
                                >
                                    <option value={''} disabled>
                                        Select an option
                                    </option>
                                    {category?.map(item =>
                                        <option value={item?.id}>{item?.title}</option>
                                    )}

                                </Form.Select> */}
                                        <div className='invalid-feedbacks' style={{ color: '#DC3544' }}>{formik.touched.selectedProduct && formik.errors.selectedProduct}</div>
                                        {/* <Form.Control.Feedback type="invalid">{formik.errors.productId}</Form.Control.Feedback> */}
                                    </Form.Group>
                                </div>
                                {/* <div className="col-lg-6">
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Sub Title</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter sub title"
                                            name='subtitle'
                                            value={formik.values?.subtitle}
                                            onChange={formik.handleChange}
                                            isValid={formik.touched.subtitle && !formik.errors.subtitle}
                                            isInvalid={formik.touched.subtitle && !!formik.errors.subtitle}
                                        />
                                        <Form.Control.Feedback type="invalid">{formik.errors.subtitle}</Form.Control.Feedback>
                                    </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                    <Form.Group controlId="formFileMultiple" className="mb-3">
                                        <Form.Label>Sub Title Image</Form.Label>
                                        <Form.Control
                                            type="file"
                                            onChange={handleSubImageChange}
                                            isInvalid={formik.touched.subtitleImage && formik.errors.subtitleImage}
                                            error={formik.errors.subtitleImage}
                                        />
                                        <Form.Control.Feedback type="invalid">{formik.errors.subtitleImage}</Form.Control.Feedback>
                                        {formik.values.subtitleImage_view &&
                                            <img src={formik.values.subtitleImage_view} alt='Category' className='mb-2' height={150} width={150} />
                                        }

                                    </Form.Group>
                                </div> */}


                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="cancle_btn" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button className="submit_btn" type="submit" disabled={loading}>
                            {loading
                                ? "Loading"
                                : selectedBanner?.id
                                    ? "Update Banner"
                                    : "Create Banner"}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </React.Fragment>
    )
}

export default CreateBanner